/**
 * Classe avec constructeur pour la liste des objets partageables
 */
export default class ShareItem{

    /**
     * Constructeur avec paramètres 
     * @param id 
     * @param label 
     * @param shareType 
     * @param share 
     * @param selected 
     */
    public constructor(id: number, label: string, shareType: string, share: boolean, selected: boolean = false){
        this.Id = id;
        this.Label = label;
        this.ShareType = shareType;
        this.Share = share;
        this.Selected = selected;
    }

    
    public Id: number;
    public Label: string;
    public ShareType : string;
    public Share: boolean;
    public Selected : boolean;
}